import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../hooks/useLanguage';

// Small always-visible EN/ES toggle. Two visual variants to match the app's
// two co-existing design languages: `css-vars` for the CSS-custom-property
// styling used by Topbar/Sidebar (PageShell family — Admin/CRM/Onboarding,
// Super Admin, Guardian Portal), `tailwind` for the utility-class styling
// used by AcademyPortalShell and the plain-Tailwind auth/public pages.
export default function LanguageChip({ variant = 'css-vars' }) {
  const { t } = useTranslation();
  const { language, setLanguage } = useLanguage();

  if (variant === 'tailwind') {
    return (
      <div
        role="group"
        aria-label={t('common:language.label')}
        className="inline-flex items-center rounded-full bg-gray-100 border border-gray-200 p-0.5"
      >
        {SUPPORTED_LANG_BUTTONS.map(({ code, label }) => (
          <button
            key={code}
            type="button"
            onClick={() => setLanguage(code)}
            aria-pressed={language === code}
            className={`px-2 py-0.5 rounded-full text-[11px] font-bold tracking-wide transition-colors ${
              language === code ? 'bg-gray-900 text-white' : 'text-gray-500'
            }`}
          >
            {label}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div
      role="group"
      aria-label={t('common:language.label')}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: 999,
        padding: 2,
        background: 'var(--bg)',
        border: '1px solid var(--border)',
      }}
    >
      {SUPPORTED_LANG_BUTTONS.map(({ code, label }) => {
        const active = language === code;
        return (
          <button
            key={code}
            type="button"
            onClick={() => setLanguage(code)}
            aria-pressed={active}
            style={{
              padding: '3px 8px',
              borderRadius: 999,
              border: 'none',
              cursor: 'pointer',
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: '0.02em',
              background: active ? 'var(--accent)' : 'transparent',
              color: active ? '#fff' : 'var(--text-3)',
              transition: 'background 0.15s, color 0.15s',
            }}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}

const SUPPORTED_LANG_BUTTONS = [
  { code: 'en', label: 'EN' },
  { code: 'es', label: 'ES' },
];
